export default __webpack_public_path__ + "static/linux-38fb4e5693327fbe604518b3922077ea.png";